import { Sort } from '@infuse/api/common';

export enum UiTableColumnAlignment {
  LEFT,
  RIGHT,
  CENTER
}

export interface UiTableColumn {
  name: string;
  label: () => string;
  field: string;
  required?: boolean;
  align?: UiTableColumnAlignment;
  format?: string;
  bold?: boolean;
  sortable?: boolean;
  copyable?: boolean;
  maxWidth?: string;
  tooltip?: () => string;
}

export enum Order {
  ASC,
  DESC,
  NONE
}

export interface ColumnSort {
  columnName: string;
  order: Order;
}

export const transformColumnSortToApiSort = (columnSort: ColumnSort): Sort | undefined => {
  if (columnSort.order === Order.NONE) {
    return;
  }

  return {
    key: columnSort.columnName,
    descending: columnSort.order === Order.DESC
  };
};

export const updateSort = (sort: Sort[], columnSort: ColumnSort): void => {
  const newSort = transformColumnSortToApiSort(columnSort);

  if (newSort) {
    const idx = sort.findIndex((s) => s.key === newSort.key);
    if (idx !== -1) {
      // Replace the existing sort.
      sort[idx] = newSort;
    } else {
      // Add new sorting:
      sort.push(newSort);
    }
  } else {
    // Remove the sort with the specified key.
    const index = sort.findIndex((s) => s.key === columnSort.columnName);
    if (index !== -1) {
      sort.splice(index, 1);
    }
  }
};
